var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M70.626 422.627L25.372 377.371C12.876 364.875 12.876 344.615 25.372 332.117L154.984 202.508L87.102 134.625C77.953 125.477 75.215 111.709 80.164 99.756C85.121 87.789 96.777 80 109.73 80H336.004C344.84 80 352.84 83.58 358.629 89.369C364.418 95.16 368 103.158 368 111.998V338.271C368 351.221 360.211 362.877 348.246 367.838C336.293 372.787 322.523 370.047 313.375 360.898L245.496 293.016L115.884 422.627C103.384 435.125 83.126 435.123 70.626 422.627Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpRight);
export default __webpack_public_path__ + "static/media/up-right.2d21482dc303631312260c5e8ff3af9e.svg";
export { ForwardRef as ReactComponent };